class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

/*
class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
*/
class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    // The overall header container
    this.header = document.querySelector('.header-wrapper');
    // The specific inline list menu container you want to target
    this.menuContainer = this.header?.querySelector('.list-menu.list-menu--inline');

    // A timer reference for the delayed close
    this.hoverDelayTimer = null;

    this.initHoverMenu();
  }

  initHoverMenu() {
    // Only apply hover behavior on desktop (adjust breakpoint as necessary)
    if (!window.matchMedia('(min-width: 1024px)').matches) return;
    if (!this.menuContainer) return;

    // ————————————————
    // 1) Open on hover over the current <details> element
    //    and close other open <header-menu> items
    // ————————————————
    this.mainDetailsToggle.addEventListener('mouseenter', () => {
      this.openMenu();
      this.closeOtherMenus();
    });

    // ————————————————
    // 2) Close after 0.3s if the mouse leaves the .list-menu--inline area entirely
    // ————————————————
    this.menuContainer.addEventListener('mouseleave', () => {
      // Start a 300ms timer
      this.hoverDelayTimer = setTimeout(() => {
        this.closeMenu();
      }, 300);
    });

    // If the user re-enters the menu before the timer expires, clear the timer
    this.menuContainer.addEventListener('mouseenter', () => {
      if (this.hoverDelayTimer) {
        clearTimeout(this.hoverDelayTimer);
        this.hoverDelayTimer = null;
      }
    });
  }

  openMenu() {
    this.mainDetailsToggle.open = true;
  }

  closeMenu() {
    this.mainDetailsToggle.open = false;
  }

  closeOtherMenus() {
    // Find all <header-menu> instances on the page
    const allMenus = document.querySelectorAll('header-menu');

    allMenus.forEach((menu) => {
      // Skip the current one
      if (menu === this) return;
      // Otherwise, close it
      menu.mainDetailsToggle.open = false;
    });
  }

  onToggle() {
    // Existing code from your class
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    // Only set the custom property once
    if (
      document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== ''
    ) return;

    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);


